/*
//css-based
//uncomment animation-related css in _panel-endorsers.scss to use
endorseHandler  = {
    $mainCarousel: $('.endorse-carousel-main'),
    carouselAnimation: null,

    init = function() {
        var self = this;

        if (this.$mainCarousel.length == 0) return;

        var $cells = this.$mainCarousel.find('.endorse-carousel-cell');
        if ($cells.length > 1) {
            var totalWidth = 0;
            $cells.each(function() {
                totalWidth += $(this).outerWidth();
            });
            this.$mainCarousel
                .width(totalWidth)
                .css({
                    'animation-duration': ($cells.length * 4)+'s',
                });
        }

        self.$mainCarousel.removeClass('paused');
        // setTimeout(function() {
        //     self.$mainCarousel.removeClass('paused');
        // }, 0); // change to maybe 3000 if initial position is on the leftmost

        $(window).on('load', function () {
            $( window ).trigger("resize");
        });
    }
}
*/

var endorseHandler  = {
    $mainCarousel: $('.endorse-carousel-main'),
    carouselAnimation: null,

    init = function() {
        var self = this;

        if (this.$mainCarousel.length == 0) return;

        var $cells = this.$mainCarousel.find('.endorse-carousel-cell');
        if ($cells.length > 1) {
            var totalWidth = 0;
            $cells.each(function() {
                totalWidth += $(this).outerWidth();
            });
        }
        this.carouselAnimation = gsap
            .to($cells, {
                duration: $cells.length * 4,
                x: "-="+totalWidth,
                ease: Linear.easeNone,
                repeat: -1,
                modifiers: {
                    x: gsap.utils.unitize(x => x % totalWidth),
                }
            })
            .delay(4);
        this.$mainCarousel
            .on("mouseenter", function() {
                self.carouselAnimation.pause();
            })
            .on("mouseleave", function() {
                self.carouselAnimation.resume();
            });

        $(window).on('load', function () {
            $( window ).trigger("resize");
        });
    }
}